module.exports = __webpack_public_path__ + "media/images/cupcake-13e33077.png";